import { Providers } from './providers'
import { AppRouter } from '../routes'
import { Toaster } from '@/shared/ui/Toaster'
import { useThemeStore } from '@/store/useThemeStore'
import { useAuthStore } from '@/store/useAuthStore'
import { requestNotificationPermission, listenForegroundMessages } from '@/lib/firebase'
import { useSyncMe } from '@/api/hooks/useAuth'
import { useEffect } from 'react'

export default function App() {
  const theme = useThemeStore(s => s.theme)
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)
  useSyncMe()
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
  }, [theme])

  // Once the user is authenticated, ask for notification permission and register
  // this browser's FCM token with the backend, then listen for foreground pushes.
  useEffect(() => {
    if (!isAuthenticated) return
    void requestNotificationPermission()
    listenForegroundMessages()
  }, [isAuthenticated])

  return (
    <Providers>
      <AppRouter/>
      <Toaster/>
    </Providers>
  )
}
